import { SceneContext } from './AnimationCanvas';

export type Palette = {
    colours: string[];
    background: string;
    foreground: string;
    muted: string;
};

const MONO = '"JetBrains Mono", monospace';

const clear = ({ ctx, width, height }: SceneContext, palette: Palette) => {
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = palette.background;
    ctx.fillRect(0, 0, width, height);
};

const pick = (palette: Palette, index: number) =>
    palette.colours[((index % palette.colours.length) + palette.colours.length) % palette.colours.length];

const alpha = (hex: string, value: number) => {
    const n = parseInt(hex.slice(1), 16);
    return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${value})`;
};

const random = (min: number, max: number) => min + Math.random() * (max - min);

export { MONO, clear, pick, alpha, random };
